let authReadyPromise = null;

export const waitForAuth = (firebaseApp) => {
  if (authReadyPromise) return authReadyPromise;
  authReadyPromise = new Promise((resolve) => {
    const auth = firebaseApp.auth();
    const unsub = auth.onAuthStateChanged(() => {
      unsub();
      resolve(auth.currentUser);
    });
  });
  return authReadyPromise;
};

export const currentUserIsAdmin = async (firebaseApp) => {
  const user = firebaseApp.auth().currentUser;
  if (!user) return false;
  const token = await user.getIdTokenResult();
  return token.claims.admin === true;
};

export const requireAdminSession = async (firebaseApp) => {
  await waitForAuth(firebaseApp);
  const user = firebaseApp.auth().currentUser;
  if (!user) return {ok: false, reason: "signed_out"};
  const token = await user.getIdTokenResult();
  if (token.claims.admin !== true) {
    return {ok: false, reason: "not_admin"};
  }
  return {ok: true, user};
};
